// extracted by mini-css-extract-plugin
export default {"message-warning":"WarningPanel_message-warning__T4BxM","icon":"WarningPanel_icon__o8omD"};